import React from "react";
import clsx from "clsx";
import FormSelect from "../../Selects/FormSelect";

class BookingButtonBuilderForm extends React.Component {

  constructor(props) {
    super(props); 
    this.onChangeForm = this.onChangeForm.bind(this)
  };

  render() { 
    var tabClasses = clsx({
			'active': this.props.active_tab == 'form',
			'tab-pane': true,
    })
    
    return (
      <div className={tabClasses} id="form">
        {this.renderFormsSelect()}
      </div>
    )
  }
  renderFormsSelect() {
    var form = null
    var changeForm = this.onChangeForm
    
    if (this.props.form) {
      form = this.props.form.id
    }
    
    this.props.forms.map((order_form) =>{
      if(order_form.id == form) {
        form = order_form
      } 
    })

    return (
      <div>
        <div className="row">
          <div className="col-sm-4 form-group" style={{marginBottom: 0}}>
            <label>{I18n.t("form")}{" "}
              <span className="ss-help help" title={I18n.t("booking_button_order_form_helper_text")}></span>
            </label>
            <br />  
            <FormSelect form={form}  onChange={changeForm} name="form" />        
          </div>
        </div>
      </div>
    )
  }

  onChangeForm(form) {
    this.props.onChangeForm(form);
  }
}

export default BookingButtonBuilderForm